// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa483778","455":"5c054496","488":"b52f80c0","977":"d686d75e"}[chunkId] + ".chunk.js";
};